import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const HotspotVoucherRoutes = defineRoute({
    record: {
        route: {
            path: "/hotspot-voucher",
            component: () => loadView(import("./HotspotVoucherTable.vue")),
        },
    },
    create: {
        route: {
            path: "/hotspot-voucher/create",
            component: () => loadView(import("./HotspotVoucherCreate.vue")),
        },
    },
    print: {
        route: {
            path: "/hotspot-voucher/print",
            component: () => loadView(import("./HotspotVoucherPrint.vue")),
        },
    },
    detail: {
        route: {
            path: "/hotspot-voucher/:id",
            component: () => loadView(import("./HotspotVoucherDetail.vue")),
        },
        build(id: string) {
            return `/hotspot-voucher/${id}`;
        },
    },
    resellerVoucher: {
        route: {
            path: "/reseller-voucher",
            component: () => loadView(import("./ResellerVoucherTable.vue")),
        },
    },
});
